angular
  .module("myApp")
  .directive(
    "pageGrid",
    ($http, $templateCache, $compile, $timeout, $rootScope, $window, $state, uuiData, StateSaver) => ({
      restrict: "A",
      templateUrl: "shared/grid/page-grid.html",
      transclude: true,
      scope: true,

      link: (scope, _element, attrs) => {
        scope.view = attrs.pageGrid
        scope.html_fields = {
          statuss: true,
          virtual_experts: true,
          lzp_eksperts_statuss: true,
          eksperts_statuss: true,
        }

        const $options = attrs.pageGridOptions ? scope.$eval(attrs.pageGridOptions) || {} : {}

        for (let opt of Object.keys($options)) {
          scope[opt] = $options[opt]
        }
        scope.buttons = $options.buttons || []

        scope.columns = []
        uuiData.metadata(scope.view).then((c) => {
          scope.columns = c
        })

        scope.sortField = null
        scope.sortDir = null
        scope.noDataLabel = "noDataLabel" in $options ? $options.noDataLabel : "Nav datu"
        scope.gridData = []

        const clean = () => {
          // nedod arī false
          const out = {}
          _.each(scope.filters, (v, k) => {
            if (v !== null && v !== "" && v !== false) out[k] = v
          })
          return out
        }

        scope.isSortable = (field) => {
          let sortable = false
          angular.forEach(scope.columns, (col) => {
            if (col.name === field && col.sortable) {
              sortable = true
            }
          })
          return sortable
        }

        scope.isSorted = (field, dir) => {
          if (field !== scope.sortField) {
            return false
          }
          return scope.sortDir === dir
        }

        scope.renderValue = (item, col) =>
          $rootScope.renderValue(col, item[col], scope.columns[col], $options.renderers, item)

        scope.sortColumn = (field) => {
          if (!scope.isSortable(field)) {
            return
          }
          if (scope.sortField === field) {
            scope.sortDir = scope.sortDir === "asc" ? "desc" : "asc"
          } else {
            scope.sortDir = "asc"
          }
          scope.sortField = field
          scope.loadPage()
        }

        scope.clearFilter = () => {
          scope.filters = $state.params.initialFilters
        }

        scope.clickRow = (row, $event) => {
          if (typeof $options.rowClick === "string") {
            if ($event.ctrlKey) {
              $window.open(
                $state.href($options.rowClick, {
                  id: row.id,
                }),
                "_blank"
              )
            } else {
              $state.go($options.rowClick, {
                id: row.id,
              })
            }
          } else if (angular.isFunction($options.rowClick)) {
            return $options.rowClick(row)
          } else if ($options.rowClick) {
            throw new Error('pageGrid.rowClick jānorāda "state.name" vai "fn(row)"!')
          }
        }

        const handleError = (e) => {
          scope.working = false
          scope.error = e.data ? e.data : e
        }

        const setCount = (c) => {
          let i, p
          scope.working = true
          scope.pages.length = 0
          if (c === undefined) {
            scope.count = undefined
          } else {
            scope.count = c
            i = 0
            p = 0
            while (i < c) {
              scope.pages.push({
                page: p,
                start: i,
                limit: scope.pagesize,
                end: Math.min(i + scope.pagesize, c),
              })
              i += scope.pagesize
              p += 1
            }
            if (!scope.pages[scope.page]) {
              scope.page = 0
            }
          }
        }

        scope.loadCount = (cb) => {
          var n
          scope.working = true
          n = $http.get(`/count/${scope.view}`, {
            params: getFilters(),
          })
          n.then((c) => {
            setCount(c.data)
            if (cb) {
              return cb()
            }
          })
          n.error(handleError)
          return n
        }

        scope.loadPage = (p) => {
          scope.working = true
          if (scope.count === void 0) {
            return scope.loadCount(() => scope.loadPage(p))
          }
          if (scope.pages.length === 0) {
            scope.working = false
            scope.gridData.length = 0
            return
          }
          if (!scope.pages[p]) {
            p = 0
          }
          scope.page = p
          const pp = scope.pages[p]
          const sortf = (scope.sortDir === "desc" ? "~" : "") + (scope.sortField ? scope.sortField : "")
          const params = angular.extend(
            {
              offset: pp.start,
              limit: pp.limit,
              sort: sortf ? sortf : undefined,
            },
            getFilters()
          )
          scope.working = true
          scope.gridData.length = 0
          return uuiData.list(
            scope.view,
            params,
            (res) => {
              _.each(res, (e) => scope.gridData.push(e))
              scope.working = false
            },
            handleError
          )
        }

        const getFilters = () => {
          const tmpObj = {}
          _.each(clean(scope.filters), (value, f) => {
            if (f === "un2adrese" && value instanceof Object) {
              if (value.pilCode) {
                tmpObj.pilseta_code = value.pilCode
              }
              if (value.novCode) {
                tmpObj.novads_code = value.novCode
              }
              if (value.pagCode) {
                tmpObj.pagasts_code = value.pagCode
              }
              tmpObj[f] = value
            } else {
              tmpObj[f] = value
            }
          })
          StateSaver.put(scope.key, tmpObj)
          return tmpObj
        }

        scope.doFilter = () => {
          scope.working = true
          setCount()
          scope.loadPage(scope.page)
        }

        scope.error = void 0
        scope.page = void 0
        scope.pages = []
        scope.pagesize = $options.perPage || 25
        scope.count = void 0
        scope.working = true
        scope.have_filter = false
        scope.key = $state.params.key || scope.view
        const stored_filters = StateSaver.get(scope.key)

        scope.filters = stored_filters || $state.params.initialFilters || {}

        if ($state.params.fixedFilters) {
          Object.keys($state.params.fixedFilters).forEach((f) => {
            scope.filters[f] = $state.params.fixedFilters[f]
          })
        }

        if ($options.filtersUrl) {
          $http
            .get($options.filtersUrl, {
              cache: $templateCache,
            })
            .success((tplContent) => {
              scope.have_filter = true
              $(".js-filter-placeholder").replaceWith($compile(tplContent)(scope))
            })
        }

        $timeout(() => scope.loadPage(0))

        scope.$on("reload", () => scope.loadPage(scope.page))
        return true
      },
    })
  )
